import cloneDeep from 'lodash/cloneDeep';
import { getRequestData } from '@/utils';
import { qryAvailableRelateOffer, setVasBsnl } from '@/pages/ModifyFeature/services/modifyFeature';

export const defaultPageInfo = {
  pageIndex: 1,
  pageCount: 10,
  totalRecord: 0,
};
const defaultState = {
  step: 0, // 修改特性的步骤
  searchCustInfo: {}, // 从搜索页面同步过来的用户信息
  serviceType: {}, // 从搜索页面同步过来的服务类型
  subServiceType: {}, // 从搜索页面同步过来的子服务类型
  featureList: [], // 可用vas列表
  pageInfo: defaultPageInfo,
  currFeatrueList: null, // 当前vas表格
  deleteFeatrueList: [], // 储存删除的vas
  setVasParams: {}, // 修改vas提交接口入参
  operationDetails: {}, // 业务数据
};
export default {
  namespace: 'modifyFeature',
  state: cloneDeep(defaultState),
  effects: {
    *qryAvailableRelateOffer({ payload }, { call, put, select }) {
      const { pageDto: paramsPageInfo } = payload;
      const { pageInfo } = yield select(state => state.modifyFeature);
      const response = yield call(qryAvailableRelateOffer, payload);
      const { offerDtoList, pageDto } = getRequestData(response);
      yield put({
        type: 'save',
        payload: {
          featureList: offerDtoList || [],
          pageInfo: paramsPageInfo.pageIndex === 1 ? (pageDto || defaultPageInfo) : ({ ...pageInfo, ...paramsPageInfo }),
        },
      });
    },
    *setVasBsnl({ payload }, { call }) {
      const response = yield call(setVasBsnl, payload);
      return getRequestData(response);
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    resetPageInfo(state) {
      return {
        ...state,
        pageInfo: defaultPageInfo,
        featureList: [],
      };
    },
    clear() {
      return cloneDeep(defaultState);
    },
  },
};
